import { Component, EventEmitter, OnInit, Output, OnDestroy } from '@angular/core';

@Component({
  selector: 'app-progress-bar',
  templateUrl: './progress-bar.component.html',
  styleUrls: ['./progress-bar.component.scss']
})
export class ProgressBarComponent implements OnInit, OnDestroy {
  progress = 0;
  strokeDashoffset = 314;
  private animationId: number | null = null;
  private hasEmitted = false;

  @Output() progressComplete = new EventEmitter<void>();

  ngOnInit(): void {
    this.animateProgress();
  }

  ngOnDestroy(): void {
    if (this.animationId) {
      cancelAnimationFrame(this.animationId);
    }
  }

  animateProgress(): void {
    const duration = Math.random() * (2000) + 4000;
    const startTime = performance.now();

    const animate = (currentTime: number) => {
      const elapsedTime = currentTime - startTime;
      const progressPercentage = Math.min((elapsedTime / duration) * 100, 100);
      this.progress = Math.round(progressPercentage);
      this.strokeDashoffset = 314 - (314 * progressPercentage) / 100;

      if (elapsedTime < duration) {
        this.animationId = requestAnimationFrame(animate);
      } else {
        // Only emit once
        if (!this.hasEmitted) {
          this.hasEmitted = true;
          console.log('Progress bar completed, emitting event');
          this.progressComplete.emit();
        }
      }
    };

    this.animationId = requestAnimationFrame(animate);
  }
}
